export default __webpack_public_path__ + "static/media/court-2.35146b71.png";